
<template>
    <div class="MainLayout" :class="{ 'MainLayout--whiteBackground': isWhiteBackgroundRoute }">
        <div
            v-if="$slots.sidebar"
            class="MainLayout__sidebar"
        >
            <slot name="sidebar" />
        </div>
        <div class="MainLayout__mainContainer">
            <header class="MainLayout__headerContainer">
                <slot name="header">
                    <div class="MainLayout__headerRow">
                        <div v-if="$slots.title" class="MainLayout__headerTitle">
                            <slot name="title" />
                        </div>
                        <nav v-if="$slots.navigation" class="MainLayout__headerNavigation">
                            <slot name="navigation" />
                        </nav>
                    </div>
                </slot>
            </header>
            <div class="MainLayout__contentContainer">
                <slot />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.MainLayout {
    $main-layout-background: var(--eidTprmBg);

    $main-layout-header-background: #fff;
    $main-layout-header-height: 67px;
    $main-layout-header-border-bottom: 1px solid rgba(#d3d3d3, 0.5);

    $main-layout-sidebar-background: $main-layout-header-background;
    $main-layout-sidebar-width: 100px;
    $main-layout-sidebar-border-side: $main-layout-header-border-bottom;
    $main-header-title-margin: 15px; // FIXME: use $main-layout-spacing
    $main-header-margin: 10px; // FIXME: use $main-layout-spacing
    $main-header-title-font-size: 1.5rem;
    $main-header-title-font-family: "Roboto";
    $main-header-navigation-element-margin: 15px; // FIXME: use $main-layout-spacing
    $main-header-user-menu-max-width: 225px;

    display: flex;
    width: 100%;
    min-width: 0;
    min-height: 100vh;
    background: $main-layout-background;

    &--whiteBackground {
        background: var(--eidWhite);
    }

    &__mainContainer {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        flex: 1 auto;
        min-width: 0;
    }

    &__headerContainer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: $main-layout-header-height;
        background: $main-layout-header-background;
        border-bottom: $main-layout-header-border-bottom;

        .UserMenu {
            max-width: $main-header-user-menu-max-width;
        }
    }

    &__headerRow {
        display: flex;
        align-items: center;
        flex: 1 auto;
    }

    &__headerTitle {
        padding-left: $main-header-title-margin;
        flex: 1 0;
        line-height: 1.05;

        h1 {
            font-family: $main-header-title-font-family, "Arial", "Tahoma", sans-serif;
            font-size: $main-header-title-font-size;
            margin: 0;
        }

        small {
            font-weight: 300;
        }
    }

    &__headerNavigation {
        flex: 1 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;

        // stylelint-disable-next-line selector-max-universal
        > * + * {
            margin-left: $main-header-navigation-element-margin;
        }
    }

    &__contentContainer {
        display: flex;
        height: calc(100vh - #{$main-layout-header-height});
        position: relative;
    }

    &__sidebar {
        width: $main-layout-sidebar-width;
        background: $main-layout-sidebar-background;
        border-right: $main-layout-sidebar-border-side;
        flex-shrink: 0;
        overflow: hidden;

        .MenuElement__linkIcon {
            flex-shrink: 0;
        }

        .MenuElement__linkText {
            white-space: nowrap;
            overflow: hidden;
        }

        .MenuElement__link {
            position: relative;
        }

        .MenuElement__endSectionContainer {
            // Make container not affect layout width when collapsed
            position: absolute;
            top: 0;
            right: 0;
            margin-left: 0;
            width: 0;
            overflow: visible;
        }

        .MenuElement__notificationBadge {
            // when closed we show the badge with count, absolutely positioned to preserve sidebar width
            position: absolute;
            top: 4px;
            right: 4px;
            width: 18px;
            height: 18px;
            font-size: 10px;
            min-width: 18px;
            z-index: 1;

            &--max {
                font-size: 9px;
            }
        }

        .MenuElement > .Menu {
            display: none;
        }
    }
}
</style>
<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'MainLayout',
        computed: {
            isWhiteBackgroundRoute(): boolean {
                return (this as any).$route?.meta?.whiteBackground === true;
            },
        },
    });
</script>
